<template>
     <div class="content">
        <div class="page-header">
            <div class="page-title">
                <h1>{{ title }}</h1>
            </div>
        </div>

        <div class="page-content">

            <div class="form-row justify-content-center">
                <div class="col-sm-6">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" :placeholder="searchText" @keyup="applyFilter('search', $event)">
                        <div class="input-group-append">
                            <span class="btn btn-primary"><i class="fas fa-search"></i></span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3 mb-3">
                    <select @change="applyFilter('filter',$event)" class="form-control">
                        <option v-for="orderstatus in orderTypeStatus" :value="orderstatus">{{orderstatus}}</option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 notifications">

                    <template v-if="notifications.length > 0">
                        <div class="timeline">
                            <template v-for="(notification, idx) in notifications" :key="notification.id">
                                <span hidden>{{ moment.locale(localeCode) }}</span>

                                <div 
                                    class="time-label" 
                                    v-if="idx == 0 || (idx > 0 && moment(notifications[idx-1].order.created_at).format('YYYY-MM-DD') != moment(notification.order.created_at).format('YYYY-MM-DD'))"
                                >
                                    <span class="bg-danger text-light">{{ moment(notification.order.created_at).format('DD MMM, YYYY') }}</span>
                                </div>

                                <div :class="notification.read ? 'read' : ''">
                                    <i class="icon order-icon" :class="notification.order.status"></i>
                                    <div class="timeline-item">
                                        <span class="time float-md-right d-block p-md-3">
                                            <i class="fa fa-clock-o"></i> {{ moment(notification.order.created_at).fromNow() }}
                                        </span>
                                        <h3 class="timeline-header pt-0 pt-md-3">
                                            <a :href="`${orderViewUrl + notification.order_id}`">
                                                #{{ notification.order.id + ' ' + orderTypeMessages[notification.order.status]}}
                                            </a>
                                        </h3>
                                    </div>
                                </div>
                            </template>

                            <div>
                                <i class="icon fas fa-clock stop"></i>
                            </div>
                        </div>

                        <pagination 
                            align="right" 
                            :data="pagNotif" 
                            show-disabled="true"
                            @pagination-change-page="getResults"
                        >
                            <span slot="prev-nav">&lsaquo;</span>
                            <span slot="next-nav">&rsaquo;</span>
                        </pagination>
                    </template>

                    <p class="text-center" v-else>
                        <strong>{{ noRecordText }}</strong>
                    </p>

                </div>
            </div>

        </div>
    </div>
</template>

<script>

    export default {

        props: [
            'url',
            'orderViewUrl',
            'pusherKey',
            'pusherCluster',
            'title',
            'orderStatus',
            'searchText',
            'noRecordText',
            'orderStatusMessages',
            'localeCode'
        ],

        data: function() {
            return {
                notifications: [],
                pagNotif: {},
                id: '',
                status: '',
                ordertype: {
                    pending : {
                        icon: 'pending-icon',
                        message: 'Order Pending'
                    },
                    processing : {
                        icon: 'processing-icon',
                        message: 'Order Processing'
                    },
                    canceled : {
                        icon: 'canceled-icon',
                        message: 'Order Canceled'
                    },
                    completed : {
                        icon: 'completed-icon',
                        message: 'Order Completed'
                    },
                    closed : {
                        icon: 'closed-icon',
                        message: 'Order Closed'
                    },
                },
                orderTypeStatus: JSON.parse(this.orderStatus),
                orderTypeMessages: JSON.parse(this.orderStatusMessages)
            }
        },

        mounted() {

            this.getNotification();

            if(Echo){
                Echo.channel('notification').listen('.create-notification', (e) => {
                    this.getNotification();
                });

                Echo.channel('notification').listen('.update-notification', (e) => {
                    this.notifications.forEach((notification)=>{
                        if(notification.order_id == e.id){
                            notification.order.status = e.status;
                        }
                    });
                });
            }
        },

        methods: {
            async getNotification() {

                const params = {};

                if(this.id){
                    params.id = this.id;
                }

                if(this.status){
                    params.status = this.status;
                }

                let this_this = this;

                await this.$http.get(this_this.url, {params: params})
                    .then (function(response) {
                        this_this.notifications = [];

                        this_this.notifications = response.data.search_results.data;
                        this_this.pagNotif = response.data.search_results;
                    }).catch (function (error) {})
            },
            applyFilter: function(type,$event){
                type == 'search' ? this.id = $event.target.value : this.status = $event.target.value;

                this.getNotification();
            },
            getResults(page  = 1){
                let this_this = this;
                axios.get(`${this.url}?page=${page}`)
                    .then(response => {
                        this_this.notifications = [];

                        this_this.notifications = response.data.search_results.data;
                        this_this.pagNotif = response.data.search_results;
                    });
            }
        }
    }
</script>